import React, { useCallback, useMemo } from 'react';
import Particles from 'react-particles';
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
  const particlesInit = useCallback(async engine => {
    await loadSlim(engine);
  }, []);

  const options = useMemo(() => ({
    fpsLimit: 60,
    particles: {
      number: {
        value: 15,
        density: {
          enable: true,
          value_area: 800
        }
      },
      color: {
        value: ["#26d0ce", "#1a2980"]
      },
      links: {
        enable: true,
        distance: 200,
        opacity: 0.03,
        width: 1
      },
      move: {
        enable: true,
        speed: 0.5,
        direction: "none",
        random: false,
        straight: false,
        outModes: {
          default: "out"
        }
      }
    },
    detectRetina: false,
    fullScreen: false
  }), []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={options}
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: 0,
        filter: "blur(10px)",
        willChange: 'transform',
        transform: 'translateZ(0)'
      }}
    />
  );
};

export default React.memo(ParticlesBackground); 